import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import { type ValidationResult } from 'types';
import { GetLocalAuthSettingsForAUserDocument } from 'types/db';
import type { ContextEntity } from './context.entity';
import { gqlClient } from 'src/util/gql-client';
import { aggregatePasswordRequirements, validateOldPasswordRequirementsAreStillStrongerThanNewPassworRequirements } from 'src/users/user.validations';

export function validateContextManageAcl (): boolean {
    return validateAcls([ 'context_update' ]);
}

export function validateContextSelectAcl (): boolean {
    return validateAcls([ 'context_select' ]);
}

export const validateContext = async (context: ContextEntity, originalEntity: ContextEntity | null): Promise<ValidationResult> => {
    if (originalEntity && context.authSettings.local.enabled) {
        for (const user of context.users) {
            const {
                argo_user_by_pk,
            } = await gqlClient.request({
                document: GetLocalAuthSettingsForAUserDocument,
                variables: {
                    userId: user.userId,
                },
            });
            if (!argo_user_by_pk) {
                return {
                    status: 'error',
                    errorMessage: 'Could not look up existing user data',
                };
            }
            const originalPolicies = argo_user_by_pk.user_contexts.filter(i => i.context.auth_provider_local_setting?.enabled).map(i => i.context.auth_provider_local_setting!.config.passwordPolicy);
            if (!validateOldPasswordRequirementsAreStillStrongerThanNewPassworRequirements({
                oldRequirements: aggregatePasswordRequirements(originalPolicies),
                newRequirements: aggregatePasswordRequirements([ context.authSettings.local.config.passwordPolicy ]),
            })) {
                return {
                    status: 'error',
                    errorMessage: 'New contexts have stricter password requirements that current contexts, the user password must be changed',
                };
            }
        }


    }

    return {
        status: 'success',
    };
};
